<div class="__wrap">

  <mat-icon
    matSuffix
    fontSet="material-icons-outlined"
    class="__visibility-icon"
    (click)="showPassword = !showPassword">
    {{ !showPassword ? 'visibility' : 'visibility_off' }}
  </mat-icon>

  <div class="__input">
    <ng-content></ng-content>
  </div>

</div>
